// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"a2-z","displaySixCardTiles":"b2-z"};